import React, { useState, useEffect } from 'react';
// import {useRouter} from 'next/router';
import { useFirstMountState } from 'react-use';
import { Formik, useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { SortPopup } from '../../../../SortPopup';
import { useShipsSearchStore } from '../../../../../providers/RootStoreProvider';
// import {FilterCheckboxes} from '../../../../FilterCheckboxes';
import { Button } from '../../../../Button';
import { Modal } from '../../../../Modal';
import { ShipCardList } from '../ShipCardList';
import { ShowMore } from '../ShowMore';
import styles from './shipMobileResult.module.sass';
import { Badge } from '../../../../Badge';
// import {sorts} from '../../../../../resources/sorts';
import { SkeletonCover } from '../../../../Skeleton/SkeletonCover';
import { EmptySearch } from '../../../../SearchCruises/EmptySearch';
import { sortShips } from '../../../../../resources/sortShips';
import { ShipFilterCheckboxes } from '../ShipFilterCheckboxes';
import { Icon } from '../../../../Icon';
import { IconSVG } from '../../../../SpriteSVG';

const AutoSubmitForm = observer(() => {
  const store = useShipsSearchStore();
  const setBottomFilters = filters => store.setBottomFilters(filters);
  // const clearFilters = () => store.clearFilters();
  const { values, submitForm, setFieldValue } = useFormikContext();

  const isFirstMount = useFirstMountState();

  useEffect(() => {
    if (!isFirstMount) {
      setBottomFilters(values);
      submitForm();
    }
  }, [values, submitForm]);

  useEffect(() => {
    if (!isFirstMount) {
      setBottomFilters(values);
      submitForm();
    }
  }, [values, submitForm]);

  useEffect(() => {
    setFieldValue('filterClasses', []);
    setFieldValue('filterServices', []);
  }, [store.filters?.type]);
  return null;
});

const COUNT_SHIPS = 10;

export const ShipMobileResult = observer(({ isMobile }) => {
  // const router = useRouter();
  // const [isTypeShipOpen, setTypeShipOpen] = useState(false);
  const [isMobileFiltersOpen, setIsMobileFiltersOpen] = useState(false);
  // const store = useSearchStore();
  // const getList = () => store.getList();
  // const setParamsFilters = params => store.setParamsFilters(params);
  // const setPage = () => store.setPage();
  // const { amount } = store;
  // const { type } = router.query;

  const btn = React.useRef();

  const store = useShipsSearchStore();

  const {
    isLoading,
    filterClasses,
    filterServices,
    filteredShips,
    shipsList,
    filters,
  } = store;

  // const getList = () => store.getList();
  const { setParamsFilters } = store;
  // const clearFilters = () => store.clearFilters();
  // const setExtraShips = params => store.setExtraShips(params);
  // const setPage = () => store.setPage();
  const [isTypeShipOpen, setTypeShipOpen] = useState(false);
  const [countShips, setCountShips] = useState(COUNT_SHIPS);
  const showMore = () => {
    setCountShips(countShips + COUNT_SHIPS);
  };

  useEffect(() => {
    store.getInitialData();
  }, []);

  const ships = filteredShips.slice(0, countShips);
  // скрытие фильтров при скроле вниз
  // let oldScrollY = 0;
  // const defaultOffset = 400;
  //
  // const scrollPosition = () =>
  //   window.pageYOffset || document.documentElement.scrollTop;
  // const containHide = () => btn.current.classList.contains(styles.hide);
  //
  // if (isClient) {
  //   window.addEventListener('scroll', () => {
  //     if (
  //       scrollPosition() > oldScrollY &&
  //       !containHide() &&
  //       scrollPosition() > defaultOffset
  //     ) {
  //       btn.current.classList.add(styles.hide);
  //     } else if (scrollPosition() < oldScrollY && containHide()) {
  //       btn.current.classList.remove(styles.hide);
  //     }
  //     oldScrollY = scrollPosition();
  //   });
  // }

  return (
    <Formik
      initialValues={{
        filterClasses: [],
        filterServices: [],
        sort: {
          sort_mode: sortShips[0].mode,
          sort_direction: sortShips[0].type,
        },
      }}
      onSubmit={async values => {
        setParamsFilters(values);
      }}
    >
      {({ values }) => {
        const services = filterServices
          .map(service => ({
            ...service,
            count: shipsList.filter(ship =>
              ship.services?.some(service1 => service1.value === service.value),
            ).length,
          }))
          .slice(0, isTypeShipOpen ? filterServices.length : 5);

        return (
          <>
            <AutoSubmitForm />
            <div className={styles.header}>
              {!store.useFirstLoad ? (
                <div className={styles.total}>
                  <span>Всего теплоходов:</span>
                  <Badge view="info" size="smUltra">
                    {filteredShips.length}
                  </Badge>
                </div>
              ) : (
                <div>
                  <SkeletonCover width={200} height={30} />
                </div>
              )}
              <SortPopup id="sort" sorts={sortShips} active={values.sort} />
            </div>
            <div className="container container--start">
              <Modal
                title="Фильтр"
                size="sm"
                isOpen={isMobileFiltersOpen}
                onOpen={setIsMobileFiltersOpen}
                actions={
                  <Button view="text" onClick={() => setIsMobileFiltersOpen()}>
                    <IconSVG name={'common/close'} width={16} height={16} />
                  </Button>
                }
                fullScreen
                hideCross
              >
                <ShipFilterCheckboxes
                  name="filterClasses"
                  title={'Теплоходы'}
                  isLoading={isLoading}
                  items={filterClasses.map(classItem => ({
                    ...classItem,
                    count: shipsList.filter(
                      ship => ship.class.value === classItem.value,
                    ).length,
                  }))}
                  ships={shipsList.map(ship => ship.class)}
                  // onShowMore={() => setTypeShipOpen(true)}
                />
                <ShipFilterCheckboxes
                  name="filterServices"
                  title={'Услуги на борту'}
                  isLoading={isLoading}
                  items={services}
                  onShowMore={
                    services.length === filterServices.length
                      ? () => setTypeShipOpen(false)
                      : () => setTypeShipOpen(true)
                  }
                  isOpen={isTypeShipOpen}
                />
                {/* <FilterCheckboxes */}
                {/*   name="typeShip" */}
                {/*   items={store.shipsClasses} */}
                {/*   onShowMore={() => { */}
                {/*     setIsMobileFiltersOpen(false); */}
                {/*     // setTypeShipOpen(true); */}
                {/*   }} */}
                {/* /> */}
                {/* <ShipFilterCheckboxes
                name="discounts"
                title="Действующие скидки"
                items={store.filterDiscounts}
                // onShowMore={() => setTypeShipOpen(true)}
              /> */}
                <Button
                  className={styles.buttonWrapper}
                  background="primary"
                  size="semi-lg"
                  onClick={() => [setIsMobileFiltersOpen(false)]}
                  fullWidth
                >
                  Показать теплоходы
                </Button>
              </Modal>
            </div>

            <div className={styles.wrapper}>
              <div>
                {ships?.length === 0 && !isLoading ? (
                  <EmptySearch />
                ) : (
                  <div>
                    <ShipCardList
                      isLoading={isLoading}
                      cruises={ships}
                      type={filters?.type}
                      isMobile={isMobile}
                    />
                    <ShowMore
                      length={filteredShips?.length}
                      amount={countShips}
                      setPage={showMore}
                    />
                  </div>
                )}
              </div>
              <div className={styles.applyFilter} ref={btn}>
                <Button
                  view="text"
                  onClick={() => setIsMobileFiltersOpen(true)}
                >
                  <div className={styles.applyFilterMargin}>
                    {values.filterClasses.length === 0 &&
                    values.filterServices.length === 0 ? (
                      <Icon
                        icon={
                          <IconSVG
                            name={'common/filter'}
                            width={17}
                            height={17}
                          />
                        }
                      />
                    ) : (
                      <Icon
                        icon={
                          <IconSVG
                            name={'common/filterRedDot'}
                            width={23}
                            height={21}
                          />
                        }
                      />
                    )}
                  </div>
                  <span>Показать фильтры</span>
                </Button>
              </div>
            </div>
          </>
        );
      }}
    </Formik>
  );
});
